import request from '../../request/request.js'
import qs from 'qs'

//登录接口
export const LoginAPI=(loginDTO)=>request.post(`/user/login`,loginDTO)
//注册接口
export const RegisterAPI=(registerDTO)=>request.post(`/user/register`,registerDTO)

export const GetVerificationCodeImgAPI=(key)=>request.get(`/user/verificationCodeImg/${key}`)



